import { createButton } from "../Button/createButton";

export const MenuButton = createButton({
  className: "tw-menu-button",
});
